<template>
  <div id="app">
    <canvas id="load" ref="load"></canvas>
    <div class="main-wrapper container">
      <Navbar iconAction="0" :changeurl="changeurl()"></Navbar>

      <nav
        class="navbar navbar-secondary"
        style="background-color: initial; box-shadow: 0 0px 0px rgb(0 0 0 / 0%)"
      ></nav>

      <!-- Main Content -->
      <div class="main-content">
        <section class="section">
          <div class="section-body">
            <div class="card col-md-6" style="margin: auto">
              <div class="card-body">
                <div class="form-row svg-container">
                  <svg
                    width="70"
                    height="70"
                    viewBox="0 0 70 70"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M35 0.125C15.7344 0.125 0.125 15.875 0.125 35C0.125 54.2656 15.7344 69.875 35 69.875C54.125 69.875 69.875 54.2656 69.875 35C69.875 15.875 54.125 0.125 35 0.125ZM35 65.375C18.2656 65.375 4.625 51.875 4.625 35C4.625 18.4062 18.125 4.625 35 4.625C51.5938 4.625 65.375 18.2656 65.375 35C65.375 51.7344 51.7344 65.375 35 65.375ZM54.8281 26.8438C55.5312 26.1406 55.5312 25.0156 54.8281 24.4531L53.7031 23.1875C53 22.4844 51.875 22.4844 51.3125 23.1875L28.25 45.9688L18.5469 36.2656C17.9844 35.5625 16.8594 35.5625 16.1562 36.2656L15.0312 37.3906C14.3281 38.0938 14.3281 39.0781 15.0312 39.7812L27.125 52.0156C27.6875 52.5781 28.8125 52.5781 29.5156 52.0156L54.8281 26.8438Z"
                      fill="#BAA16F"
                    />
                  </svg>
                </div>
                <div class="form-row">
                  <h3 style="margin: auto; text-align: center">
                    <font v-if="!isCN">{{ $t("Registered Successfully") }}</font>
                    <font v-if="isCN">{{ $t("Registered Successfully CN") }}</font>
                  </h3>
                </div>
                <div class="form-row">
                  <p
                    style="
                      margin: auto;
                      padding-bottom: 10px;
                      text-align: center;
                    "
                  >
                    <font v-if="!isCN">{{
                      $t("Your account information has been sent to the email")
                    }}
                    {{ email }}
                    </font>
                      <font v-if="isCN">{{
                      $t("Your account information has been sent to the email CN")
                    }}
                    {{ email }}
                    </font>
                  </p>
                </div>

                <button class="btn btn-primary col-md-12" @click="backhome()">
                  <span id="loading" ref="loading">{{ $t("Done") }}</span>
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<style>
#country_code {
  border: none;
  border-bottom: 1px solid #000000;
}

canvas {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  box-sizing: border-box;
  margin: 0;
  width: 100%;
  height: 100%;
}

.vue-country-select .current .country-code {
  margin-left: 10px;
  margin-right: 10px;
}

.form-row {
  width: 100%;
  display: flex;
  justify-content: center;
}

.svg-container {
  padding: 2px;
}
</style>
<script>
import { mapActions, mapGetters } from "vuex";
import Navbar from "@/components/Navbar.vue";

export default {
  components: { Navbar },
  data() {
    return {
      email: null,
      callbackurl: null,
      isCN:null
    };
  },
  created() {
    this.isCN =  window.sessionStorage.getItem("isCN");
    this.callbackurl = window.sessionStorage.getItem("callbackurl");
    this.email = window.sessionStorage.getItem("email");
    window.sessionStorage.clear();
    if (this.email == null) {
      window.location.href = "./";
    }
    var char = "";
    var char2 = this.email.indexOf("@");
    for (var i = 1; i < char2; i++) {
      char += "*";
    }
    this.email =
      this.email.slice(0, 1) +
      char +
      this.email.slice(char2, this.email.length);
  },
  computed: {
    ...mapGetters("grid", ["getGridById"]),
    ...mapGetters(["getIsBlock"]),
  },
  mounted() {},
  methods: {
    ...mapActions("grid", [
      "actionResetGrid",
      "actionSetGrid",
      "actionRequest",
    ]),
    ...mapActions("filters", ["actionFindNow", "actionFindNowById"]),
    ...mapActions(["actionSetForceBlock", "actionSetBlock"]),
  changeurl() {
    window.sessionStorage.setItem("callbackurl", this.callbackurl);
  },
    backhome() {
      if (window.__wxjs_environment === 'miniprogram') {
        wx.miniProgram.navigateBack({
          url: this.callbackurl,
          success: function () {
            console.log('success')
          },
          fail: function () {
            console.log('fail');
          },
          complete: function () {
            console.log('complete');
          }
        });
      } else if (this.callbackurl != null && this.callbackurl != "" && this.callbackurl != "null") {
        window.location.href = this.callbackurl;
      } else {
        window.location.href = "./#/";
      }
    },

  },
};
</script>
